export function throttle(func, periodMS = 100) {
    var timer;
    return function(event) {
      if(timer) return;
      func();
      timer = setTimeout(function () {
        timer = null;
      }, periodMS, event);
    };
}